module.exports = __webpack_public_path__ + "static/media/client-setup-questionnaire.2b75098d.svg";